import { create } from 'zustand';
import { WHITE } from '../constants/App';
import { PLEASE_WAIT } from '../constants/ContextConstants';
import { FutureDateBannerData, StoreCloseBannerData } from '../components/Interfaces/OrderAheadPopupInterface';
import { GilmorePromoDataInterface } from '../components/HappyGilmore/HappyGilmoreModal';

interface GlobalState {
  isSetFavourite: boolean;
  showFavourite: () => void;
  isSetOnboardingVisible: boolean;
  onboardingVisible: () => void;
  isSetBestSeller: boolean;
  isBestSeller: () => void;
  appConfig: any;
  setAppConfig: (appConfig: any) => void;
  showToastBanner: boolean;
  isShowToastBanner: () => void;
  isHideToastBanner: () => void;
  toastBanner: any;
  setToastBanner: (toastBanner: any) => void;
  removeToastBanner: () => void;
  analyticsProducts: any;
  setAnalyticsProducts: (result: any) => void;
  attemptTracter: any[];
  setAttemptTracker: (values: any[]) => void;
  pageLoadAnalytics: number;
  setPageLoadAnalytics: (value: number) => void;
  noOFComponents: any[];
  setNoOfComponents: (value: any[]) => void;
  totalCards: number;
  setTotalCards: (value: number) => void;
  selectedCard: number;
  setSelectedCard: (value: number) => void;
  cartID: string;
  setCartID: (value: string) => void;
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
  cookieOptions: any[];
  pageDetails: any;
  setPageDetails: (value: string) => void;
  bonusObject: any;
  setBonusObject: (value: any) => void;
  isShowPaypalBanner: boolean;
  showPaypalBanner: (value: boolean) => void;
  cartQuantity: any;
  setCartQuantity: (value: any) => void;
  showAnimation: boolean;
  setShowAnimation: (value: boolean) => void;
  headerHeightCal: string;
  setHeaderHeight: (value: string) => void;
  bannerHeightCal: number;
  setBannerHeightCal: (value: number) => void;
  closeDeliveryLocator: boolean;
  setRemovedProductData: (value: any[]) => void;
  removedProductData: any[];
  setCloseDeliveryLocator: (value: boolean) => void;
  isHeaderLoad: boolean;
  setHeaderLoad: (value: boolean) => void;
  contextLoader: any;
  setContextLoader: (value: any) => void;
  contextCardLoader: any;
  setContextCardLoader: (value: any) => void;
  pageDisplayName: any;
  setPageDisplayName: (value: any) => void;
  selectedPickupTimeIndex: number;
  setSelectedPickupTimeIndex: (value: any) => void;
  selectedTimePicker: { analyticsText: string, text: string, value: string } | null;
  setSelectedTimePicker: (value: { analyticsText: string, text: string, value: string }) => void;
  selectedvehicledetails: { selectedVehicleType: string, selectedVehicleColor: string },
  setSelectedvehicledetails: (value: { selectedVehicleType: string, selectedVehicleColor: string }) => void,
  fulfillmentEditModal: {
    showFulfillmentEditModal: boolean,
    headerTitle: string,
    subPageFeature: string,
    isModalOpenFromCheckoutCta?: boolean,
  },
  setFulfillmentEditModal: (value: {
    showFulfillmentEditModal: boolean,
    headerTitle: string,
    subPageFeature: string,
    isModalOpenFromCheckoutCta?: boolean,
  }) => void,
  selectedDatePicker: string;
  setSelectedDatePicker: (value: string) => void;
  currentfulFillmentType: string,
  setCurrentfulFillmentType: (value: string) => void;
  selectedTimePickerDelivery: { analyticsText: string, text: string, value: string } | null;
  setSelectedTimePickerDelivery: (value: { analyticsText: string, text: string, value: string }) => void;
  categories: any[];
  setCategories: (value: any[]) => void;
  deliveryAvailableTimeList: any[];
  setDeliveryAvailableTimeList: (value: { analyticsText: string, text: string, value: string }[]) => void;
  focusReturnToTriggerElement: any;
  setFocusReturnToTriggerElement: (value: any) => void;
  storeCloseBannerData: StoreCloseBannerData | null;
  setStoreCloseBannerData: (value: StoreCloseBannerData) => void;
  isWebOrderAvailable: boolean,
  setIsWebOrderAvailable: (value: boolean) => void;
  gilmorePromoData: any;
  setGilmorePromoData: (value: any) => void;
  isShowGilmoreModal: boolean;
  setIsShowGilmoreModal: (value: boolean) => void;
  futureDateBannerData: FutureDateBannerData | null;
  setFutureDateBannerData: (value: FutureDateBannerData | null) => void;
  isMealOfTheDay: boolean;
  setIsMealOfTheDay: (value: boolean) => void;
  isOrderAhead: boolean;
  setIsOrderAhead: (value: boolean) => void;
  isFutureDateSelected: boolean;
  setIsFutureDateSelected: (value: boolean) => void;
  expectedReadyByTime: string | null;
  setExpectedReadyByTime: (value: string | null) => void;
  readyByTime: string | Date;
  setReadyByTime: (value: string | Date) => void;
  shouldReadyByTimeUpdate: boolean;
  setShouldReadyByTimeUpdate: (value: boolean) => void;
  isDeliveryEstimatedStatus: boolean;
  setIsDeliveryEstimatedStatus: (value: boolean) => void;
}

const $SHOW_TOAST_BANNER = 'showToastBanner';

const getInitialToastBanner = () => {
  const value =
    localStorage.getItem($SHOW_TOAST_BANNER) === 'true' ||
    window.orderViewModel.showRedirectSuccessBanner;
  return value || false;
};

const $TOAST_BANNER_MESSAGE = 'toastBannerMessage';

const getInitialToastBannerMessage = () => {
  let details;
  const value = localStorage.getItem($TOAST_BANNER_MESSAGE) === 'true';
  return value ? details : '';
};

const useStore = create<GlobalState>(set => ({
  isSetFavourite: false,
  showFavourite: () => set({ isSetFavourite: true }),
  isSetBestSeller: false,
  isBestSeller: () => set({ isSetBestSeller: true }),
  isSetOnboardingVisible: false,
  onboardingVisible: () => set({ isSetOnboardingVisible: true }),
  appConfig: {},
  setAppConfig: appConfig => set(state => ({ ...state.appConfig, appConfig })),
  toastBanner: getInitialToastBannerMessage(),
  setToastBanner: (toastBanner: any) =>
    set(() => {
      localStorage.setItem($TOAST_BANNER_MESSAGE, true as any);
      return {
        toastBanner: toastBanner,
      };
    }),
  removeToastBanner: () =>
    set(() => {
      localStorage.removeItem($TOAST_BANNER_MESSAGE);
      return {
        toastBanner: undefined,
      };
    }),
  analyticsProducts: {},
  setAnalyticsProducts: (result: any) =>
    set(state => ({ ...state.analyticsProducts, analyticsProducts: result })),
  showToastBanner: getInitialToastBanner(),
  isShowToastBanner: () =>
    set(() => {
      localStorage.setItem($SHOW_TOAST_BANNER, true as any);
      return {
        showToastBanner: true,
      };
    }),
  isHideToastBanner: () =>
    set(() => {
      localStorage.removeItem($SHOW_TOAST_BANNER);
      return {
        showToastBanner: false,
      };
    }),
  attemptTracter: [],
  setAttemptTracker: (value: any[]) =>
    set(state => ({ ...state.attemptTracter, attemptTracter: value })),
  pageLoadAnalytics: 0,
  setPageLoadAnalytics: (value: number) => set({ pageLoadAnalytics: value }),
  noOFComponents: [],
  setNoOfComponents: (value: any) =>
    set(state => ({ ...state.noOFComponents, noOFComponents: value })),
  removedProductData: [],
  setRemovedProductData: (value: any) =>
    set({ removedProductData: value }),
  totalCards: 0,
  setTotalCards: (value: number) => set({ totalCards: value }),
  selectedCard: 0,
  setSelectedCard: (value: number) => set({ selectedCard: value }),
  cartID: window.orderViewModel.currentOrder.cartId,
  setCartID: (value: string) => set({ cartID: value }),
  isLoggedIn: false,
  setIsLoggedIn: (value: boolean) => set({ isLoggedIn: value }),
  cookieOptions: [],
  pageDetails: null,
  setPageDetails: (value: string) => set({ pageDetails: value }),
  bonusObject: null,
  setBonusObject: (value: any) => set({ bonusObject: value }),
  isShowPaypalBanner: false,
  showPaypalBanner: (value: boolean) => set({ isShowPaypalBanner: value }),
  cartQuantity: window.orderViewModel.currentOrder.cartQuantity,
  showAnimation: false,
  setShowAnimation: (value: boolean) => set({ showAnimation: value }),
  setCartQuantity: (value: any) => set((state) => {
    return {
      cartQuantity: value,
      showAnimation: state.cartQuantity == 0 ? true : false
    }
  }),
  headerHeightCal: '0px',
  setHeaderHeight: (value: string) => set({ headerHeightCal: value }),
  bannerHeightCal: 0,
  setBannerHeightCal: (value: number) => set({ bannerHeightCal: value }),
  closeDeliveryLocator: false,
  setCloseDeliveryLocator: (value: boolean) => set({ closeDeliveryLocator: value }),
  isHeaderLoad: false,
  setHeaderLoad: (value: boolean) => set({ isHeaderLoad: value }),
  contextLoader: { animationColor: WHITE, buttonId: '', isLoading: false, targetElement: null, ariaLabelText: window.pleaseWaitValue || PLEASE_WAIT, dancingBubbleTargetId: '', },
  setContextLoader: (value: any) => set((state) => ({
    contextLoader: {
      ...state.contextLoader,
      ...value,
    },
  })),
  contextCardLoader: { cardId: '' },
  setContextCardLoader: (value: any) => set({ contextCardLoader: value }),
  pageDisplayName: null,
  setPageDisplayName: (value: any) => set({ pageDisplayName: value }),
  selectedPickupTimeIndex: 0,
  setSelectedPickupTimeIndex: (value: number) => set({ selectedPickupTimeIndex: value }),
  selectedTimePicker: null,
  setSelectedTimePicker: (value: { analyticsText: string, text: string, value: string }) => set({ selectedTimePicker: value }),
  selectedvehicledetails: { selectedVehicleType: '', selectedVehicleColor: '' },
  setSelectedvehicledetails: (value: { selectedVehicleType: string, selectedVehicleColor: string }) => set({ selectedvehicledetails: value }),
  fulfillmentEditModal: {
    showFulfillmentEditModal: false,
    headerTitle: "",
    subPageFeature: "",
    isModalOpenFromCheckoutCta: false,
  },
  setFulfillmentEditModal: (value: {
    showFulfillmentEditModal: boolean,
    headerTitle: string,
    subPageFeature: string,
    isModalOpenFromCheckoutCta?: boolean
  }) => set({ fulfillmentEditModal: value }),
  selectedDatePicker: '',
  setSelectedDatePicker: (value: string) => set({ selectedDatePicker: value }),
  currentfulFillmentType: '',
  setCurrentfulFillmentType: (value: string) => set({ currentfulFillmentType: value }),
  selectedTimePickerDelivery: null,
  setSelectedTimePickerDelivery: (value: { analyticsText: string, text: string, value: string }) => set({ selectedTimePickerDelivery: value }),
  categories: [],
  setCategories: (value: any[]) => set({ categories: value }),
  deliveryAvailableTimeList: [],
  setDeliveryAvailableTimeList: (value: { analyticsText: string, text: string, value: string }[]) => set({ deliveryAvailableTimeList: value }),
  focusReturnToTriggerElement: null,
  setFocusReturnToTriggerElement: (value: any) => set({ focusReturnToTriggerElement: value }),
  storeCloseBannerData: null,
  setStoreCloseBannerData: (value: StoreCloseBannerData | null) => set({ storeCloseBannerData: value }),
  isWebOrderAvailable: true,
  setIsWebOrderAvailable: (value: boolean) => set({ isWebOrderAvailable: value }),
  gilmorePromoData: {},
  setGilmorePromoData: (value: GilmorePromoDataInterface) => set({ gilmorePromoData: value }),
  isShowGilmoreModal: false,
  setIsShowGilmoreModal: (value: boolean) => set({ isShowGilmoreModal: value }),
  futureDateBannerData: null,
  setFutureDateBannerData: (value: FutureDateBannerData | null) => set({ futureDateBannerData: value }),
  isMealOfTheDay: false,
  setIsMealOfTheDay: (value: boolean) => set({ isMealOfTheDay: value }),
  isOrderAhead: false,
  setIsOrderAhead: (value: boolean) => set({ isOrderAhead: value }),
  isFutureDateSelected: false,
  setIsFutureDateSelected: (value: boolean) => set({ isFutureDateSelected: value }),
  expectedReadyByTime: null,
  setExpectedReadyByTime: (value: string | null) => set({ expectedReadyByTime: value }),
  readyByTime: '',
  setReadyByTime: (value: string | Date) => set({ readyByTime: value }),
  shouldReadyByTimeUpdate: true,
  setShouldReadyByTimeUpdate: (value: boolean) => set({ shouldReadyByTimeUpdate: value}),
  isDeliveryEstimatedStatus: false,
  setIsDeliveryEstimatedStatus: (value: boolean) => set({ isDeliveryEstimatedStatus: value})
}));

export default useStore;
